import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=04ca1c4a&scoped=true&"
import script from "./memberList.vue?vue&type=script&lang=js&"
export * from "./memberList.vue?vue&type=script&lang=js&"
import style0 from "./memberList.vue?vue&type=style&index=0&id=04ca1c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca1c4a",
  null
  
)

export default component.exports